import React, { useState, useEffect } from "react";

function LoadingIndicator() {
  const [dots, setDots] = useState<string>("...");

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prevDots) => {
        if (prevDots === "...") {
          return ".";
        } else if (prevDots === ".") {
          return "..";
        } else if (prevDots === "..") {
          return "...";
        }
        return "";
      });
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="ai-bot-response-container">
      
      <div className="ai-bot-response">
        <div className="ai-bot-content">
          <p>{dots}</p>
          <span className="ai-bot-avatar">
                  <img
                    src="image/chatbot-avatar.svg"
                    alt="chatbot avatar icon"
                  />
                  </span>
        </div>
        
      </div>
    </div>
  );
}

export default LoadingIndicator;
